
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import URI from 'urijs';

import { sagas as sagasMap } from '../../map';
import { sagas as sagasMultiScene } from '../../multiscene';
import appGetActions from '../../app/saga';
import { MultiScene, componentDidUpdateInitViewFromUrl } from '../../multiscene';
import getAppModules from './getAppModules';

/**
 * Viewer containing 3D scene window for sphere photo.
 *
 * @reactProps {Object} projectDefinition - project definition
 * @reactProps {Object} map - actual map state
 */
class SpherePhotoBasicViewer extends Component {

    classNames = mergeStyleSets({
    });

    constructor(props) {
        super(props);
        this._multiSceneComponent = null;
    }

    componentDidUpdate(prevProps) {
        componentDidUpdateInitViewFromUrl(
            this._multiSceneComponent, this.props, prevProps
        );
    }

    getAppModules() {
        return getAppModules(this.props.projectDefinition);
    }

    getProjectUrl() {
        let uri = new URI(this.props.projectDefinition.multiSceneProject.url);
        uri.setSearch('process', 'removePointCloud');
        return uri.toString();
    }

    render() {
        return (
            <Stack horizontal styles={{root: {height: '100%'}}} tokens={{childrenGap: 0, padding: 5}}>
                {this.renderMultiScene()}
            </Stack>
        );
    }

    renderMultiScene(layoutValues) {
        return (
            <Stack.Item grow={1} className={this.classNames.multiScene}>
                <MultiScene
                    ref={element => this._multiSceneComponent = element}
                    projectUrl={this.getProjectUrl()}
                    initialized={this.props.multiScene.initialized}
                    mode="pano"
                    initialMode="pano"
                    modes={['pano']}
                    disableMeasure={true}
                    commands={this.props.multiScene.commands}
                    layers={this.props.map.layers}
                    multiSceneActions={this.props.multiSceneActions}
                    showHomeScene={true}
                />
            </Stack.Item>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        mapActions: sagasMap.getActions(dispatch),
        multiSceneActions: sagasMultiScene.getActions(dispatch),
        appActions: appGetActions(dispatch)
    };
}

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        auth: state.auth,
        urlParams: state.app.urlParams,
        multiScene: state.multiScene.multiScene
    };
}

const ConnectedSpherePhotoBasicViewer = connect(mapStateToProps, mapDispatchToProps)(SpherePhotoBasicViewer);

export default ConnectedSpherePhotoBasicViewer;
